<h1 mat-dialog-title class="headline">Mail speichern</h1>
<p>{{ paragraph }}</p>
<mat-dialog-actions>
    <button app-button [mat-dialog-close]="undefined" Inverted Color="cancel">abbrechen</button>
    <button app-button [mat-dialog-close]="'revert'" Color="red">Änderungen verwerfen</button>
    <button app-button [mat-dialog-close]="'save'" Color="green">speichern</button>
</mat-dialog-actions>
